import { getPaymentRateReducer } from "./pay-rate"
import { getGcashAccountListsReducer } from "./gcash-acc"
import { gcashAddTransactionReducer } from "./gcash-add-transaction"
import { getCashoutListsReducer } from "./co-list"
import { cashoutRegisterReducer } from "./co-register"
import { getCashoutHistoryReducer } from "./co-history"
import { giftcodeClaimReducer } from "./giftcode-claim"

import { getRewardInfoReducer } from "./rw-info"
import { getRewardFriendsReducer } from "./rw-friends"
import { getRewardHistoryReducer } from "./rw-history"
import { getRewardHistoryInfoReducer } from "./rw-history-info"
import { combineReducers } from 'redux';

const cashout = combineReducers({
    history: getCashoutHistoryReducer,
    register: cashoutRegisterReducer,
    lists: getCashoutListsReducer
})
const gcash = combineReducers({
    list: getGcashAccountListsReducer,
    addtransaction: gcashAddTransactionReducer
})

const reward = combineReducers({
    info: getRewardInfoReducer,
    friends: getRewardFriendsReducer,
    history: getRewardHistoryReducer,
    historyInfo: getRewardHistoryInfoReducer
})
export default combineReducers({
    payrate: getPaymentRateReducer,
    // gcashlists: getGcashAccountListsReducer,
    // gcashaddtransaction: gcashAddTransactionReducer,
    gcash: gcash,
    cashout: cashout,
    giftcode: giftcodeClaimReducer,
    // colists: getCashoutListsReducer,
    // coregister: cashoutRegisterReducer,
    // coHistory : getCashoutHistoryReducer
    reward: reward
});